<template>
  <div class="DHeader">
    <template v-if="isLoggedIn">
      <section class="DHeader__items">
        <button
          v-show="!getter_is_side_menu_open"
          v-if="supportLeftSide"
          class="DHeader__drawerBtn"
          @click.stop="clickWorkspaceGroupMenuBtn"
        >
          <font-awesome-icon :icon="['far', 'chevrons-right']" />
        </button>
        <d-nav-dropdown :access="access" />
      </section>
      <user-avatar v-if="!isMobileDevice" @open-user-profile="$emit('open-user-profile')" />
    </template>

    <template v-else>
      <div class="DHeader__deephowLogo DHeader__deephowLogo--lg"></div>
      <section class="DHeader__items">
        <div class="DHeader__languageBtn">
          <user-language-menu isMobileDevice class="hidden-sm-and-up"></user-language-menu>
          <user-language-menu :isTabletDevice="isTabletDevice" class="hidden-xs-only"></user-language-menu>
        </div>
        <a
          target="_blank"
          href="https://www.deephow.com/"
          class="DHeader__aboutBtn body-2 white--text text-capitalize mr-2 ml-4 text-no-wrap"
        >
          <span class="hidden-sm-and-up">{{ $t("auth.about") }}</span>
          <span class="hidden-xs-only">{{ $t("auth.aboutDeephow") }}</span>
        </a>
      </section>
    </template>
  </div>
</template>

<script>
import IconBase from "@/components/IconBase.vue";
import DIconSideBar from "@/components/icons/DIconSideBar.vue";
import DNavDropdown from "@/components/DHeader/DNavDropdown.vue";
import UserAvatar from "@/components/DUser/UserAvatar";
import UserLanguageMenu from "@/components/DUser/UserLanguageMenu";
import { IS_TABLET, IS_MOBILE } from "@/constants/device-version";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "DHeader",
  props: {
    supportLeftSide: Boolean,
    isLoggedIn: Boolean,
    access: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isTabletDevice: IS_TABLET,
      isMobileDevice: IS_MOBILE,
    };
  },
  components: {
    IconBase,
    DIconSideBar,
    DNavDropdown,
    UserAvatar,
    UserLanguageMenu,
  },
  computed: {
    ...mapGetters("global", ["getter_is_side_menu_open"]),
  },
  methods: {
    ...mapActions("global", ["closeSideBar", "openSideBar"]),
    clickWorkspaceGroupMenuBtn() {
      if (this.getter_is_side_menu_open) {
        this.closeSideBar();
      } else {
        this.openSideBar();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.DHeader {
  position: relative;
  width: 100%;
  min-height: var(--header-height);
  padding: 0 32px 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #121314;
  &__items {
    display: flex;
    align-items: center;
  }
  &__drawerBtn {
    width: 40px;
    height: 40px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 1px solid #28292e;
    color: #9397a6;
    background-color: #1d1e21;
    &:hover {
      color: #ffffff;
    }
  }
  &__deephowLogo {
    width: 124px;
    height: 30px;
    background-image: url("../../img/deephow-logo.png");
    background: url("data:image/svg+xml,%3Csvg width='155' height='34' viewBox='0 0 155 34' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M13.69 23.06a5.599 5.599 0 0 0 2.156-2.256c.516-.968.774-2.08.774-3.333 0-1.253-.258-2.364-.774-3.333a5.493 5.493 0 0 0-2.155-2.24c-.92-.524-1.942-.786-3.064-.786-1.145 0-2.172.262-3.08.786-.91.525-1.628 1.271-2.155 2.24-.528.969-.792 2.08-.792 3.333 0 1.254.264 2.365.792 3.333.527.969 1.245 1.721 2.154 2.256.91.536 1.936.804 3.081.804 1.122 0 2.143-.268 3.064-.804zm6.128-21.896V26.53h-3.097v-2.872a7.021 7.021 0 0 1-2.727 2.291c-1.1.525-2.312.787-3.636.787-1.729 0-3.278-.388-4.646-1.163a8.262 8.262 0 0 1-3.216-3.265c-.774-1.401-1.161-3.014-1.161-4.837s.387-3.43 1.161-4.82a8.295 8.295 0 0 1 3.216-3.248C7.08 8.628 8.629 8.24 10.358 8.24c1.279 0 2.457.246 3.535.736a6.883 6.883 0 0 1 2.693 2.17V1.165h3.232zM27.906 11.91c-1.061.967-1.683 2.232-1.866 3.796h11.638c-.183-1.54-.804-2.8-1.865-3.778-1.061-.977-2.38-1.466-3.954-1.466-1.574 0-2.892.483-3.953 1.449m12.853 6.176H26.04c.206 1.61.907 2.904 2.105 3.882 1.198.978 2.687 1.466 4.467 1.466 2.168 0 3.914-.736 5.237-2.208l1.815 2.139a7.946 7.946 0 0 1-3.064 2.208c-1.221.506-2.584.76-4.09.76-1.917 0-3.617-.398-5.1-1.191-1.484-.793-2.63-1.903-3.44-3.33-.81-1.426-1.216-3.036-1.216-4.83 0-1.771.394-3.37 1.182-4.796.787-1.426 1.87-2.536 3.251-3.33 1.38-.793 2.938-1.19 4.672-1.19 1.734 0 3.28.397 4.638 1.19 1.358.794 2.419 1.904 3.183 3.33.765 1.426 1.147 3.06 1.147 4.9 0 .253-.023.586-.068 1M47.987 11.91c-1.061.967-1.683 2.232-1.866 3.796H57.76c-.183-1.54-.804-2.8-1.865-3.778-1.061-.977-2.38-1.466-3.954-1.466-1.574 0-2.892.483-3.953 1.449m12.853 6.176H46.12c.206 1.61.907 2.904 2.105 3.882 1.198.978 2.687 1.466 4.467 1.466 2.168 0 3.914-.736 5.237-2.208l1.815 2.139a7.946 7.946 0 0 1-3.064 2.208c-1.221.506-2.584.76-4.09.76-1.917 0-3.617-.398-5.1-1.191-1.484-.793-2.63-1.903-3.44-3.33-.81-1.426-1.216-3.036-1.216-4.83 0-1.771.394-3.37 1.181-4.796.788-1.426 1.871-2.536 3.252-3.33 1.38-.793 2.938-1.19 4.672-1.19 1.734 0 3.28.397 4.638 1.19 1.358.794 2.419 1.904 3.184 3.33.764 1.426 1.146 3.06 1.146 4.9 0 .253-.023.586-.068 1M75.36 22.731c.922-.544 1.65-1.308 2.185-2.293.535-.985.802-2.114.802-3.389 0-1.273-.267-2.403-.802-3.388-.535-.984-1.263-1.743-2.185-2.276-.922-.533-1.963-.8-3.124-.8-1.138 0-2.168.273-3.09.817a5.868 5.868 0 0 0-2.184 2.277c-.535.973-.802 2.097-.802 3.37 0 1.275.26 2.404.785 3.389a5.673 5.673 0 0 0 2.185 2.293c.933.545 1.968.817 3.106.817 1.161 0 2.202-.272 3.124-.817m1.86-13.883a8.427 8.427 0 0 1 3.26 3.302c.786 1.413 1.179 3.046 1.179 4.9 0 1.853-.393 3.492-1.178 4.917a8.39 8.39 0 0 1-3.26 3.319c-1.389.788-2.96 1.181-4.712 1.181-1.297 0-2.486-.255-3.567-.765a7.442 7.442 0 0 1-2.748-2.224V33h-3.278V7.84h3.141v2.92a6.986 6.986 0 0 1 2.765-2.311c1.115-.522 2.344-.782 3.687-.782 1.753 0 3.323.394 4.712 1.181' fill='%234689F3'/%3E%3Cpath d='M108.306 25.126a8.689 8.689 0 0 1-3.35-3.33c-.806-1.415-1.208-3.02-1.208-4.813 0-1.794.402-3.399 1.207-4.814a8.57 8.57 0 0 1 3.35-3.312c1.43-.793 3.039-1.19 4.831-1.19 1.791 0 3.396.397 4.813 1.19a8.612 8.612 0 0 1 3.334 3.312c.804 1.415 1.207 3.02 1.207 4.814s-.403 3.398-1.207 4.813a8.732 8.732 0 0 1-3.334 3.33c-1.417.805-3.022 1.207-4.813 1.207-1.792 0-3.402-.402-4.83-1.207zm7.942-2.502c.919-.54 1.638-1.3 2.16-2.277.522-.977.783-2.099.783-3.364 0-1.265-.261-2.386-.783-3.364-.522-.978-1.241-1.731-2.16-2.26-.918-.53-1.956-.794-3.112-.794-1.157 0-2.194.265-3.112.794-.919.529-1.645 1.282-2.177 2.26-.534.978-.8 2.099-.8 3.364 0 1.265.266 2.387.8 3.364.532.978 1.258 1.737 2.177 2.277.918.54 1.955.811 3.112.811 1.156 0 2.194-.27 3.112-.81zM99.76 10.064c1.32 1.332 1.98 3.284 1.98 5.856v10.413h-3.194V16.295c0-1.752-.41-3.072-1.231-3.96-.821-.888-1.996-1.332-3.527-1.332-1.73 0-3.094.518-4.092 1.554-.998 1.036-1.497 2.521-1.497 4.456v9.32h-3.194V1H88.2v9.799c.665-.865 1.536-1.537 2.612-2.015 1.075-.478 2.279-.717 3.61-.717 2.24 0 4.02.666 5.339 1.998m53.52-1.732l-6.723 18h-3.124l-5.196-13.653-5.264 13.653h-3.124l-6.69-18h3.09l5.23 14.333 5.434-14.333h2.75l5.332 14.4 5.365-14.4h2.92z' fill='%23FFF'/%3E%3C/g%3E%3C/svg%3E")
      no-repeat center;
    background-size: 100%;
    &--lg {
      width: 155px;
      height: 34px;
    }
  }
  &__languageBtn {
    height: 48px;
    padding: 0 24px 0 24px;
    border-right: #35373d 1px solid;
    display: flex;
    align-items: center;
  }
  &__aboutBtn {
    text-decoration: none;
  }
}
</style>
